export enum BlueMediaMerchantFormAction {
  REGISTRATION = 'REGISTRATION',
  UPDATE = 'UPDATE',
  ADD_SERVICE = 'ADD_SERVICE',
}
